import { useState } from "react";
import { PanelShell, StatChip, Badge, TextField, tokens } from "../index";
import { createDistroKidReadinessReport } from "@djsem/analysis-contract";

/**
 * Releases module — a minimal release form (artist, title, rights confirmation) that runs the
 * real DistroKid readiness check live (prompt-115 logic) so users see genuine blockers before
 * submitting, plus a DistroKid bridge info panel.
 *
 * @returns A release-readiness panel with live score/status/blockers, and a DistroKid bridge info panel.
 */
export function ReleasesModule() {
  const [artist, setArtist] = useState("");
  const [title, setTitle] = useState("");
  const [rights, setRights] = useState(false);
  // Deliberately leave artwork/audio refs unset: the readiness checker should show those as
  // real blockers for a draft — honest preview of what a release still needs.
  const report = createDistroKidReadinessReport({
    releaseId: "draft", artistName: artist || undefined, releaseTitle: title || undefined,
    primaryGenre: "House", language: "en", releaseDate: "2026-01-01", explicit: false,
    rightsConfirmed: rights,
    tracks: [{ title: title || undefined }],
  });
  const field = (label: string, v: string, set: (s: string) => void) => (
    <label style={{ display: "block", fontSize: 11, color: tokens.color.muted, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 10 }}>
      {label}
      <TextField value={v} onChange={set} style={{ display: "block", width: "100%", boxSizing: "border-box", marginTop: 4, padding: "8px 10px", fontSize: 13 }} />
    </label>
  );
  return (
    <>
      <PanelShell title="Release readiness — live check">
        {field("Artist name", artist, setArtist)}
        {field("Release title", title, setTitle)}
        <label style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 13, color: tokens.color.textDim, marginBottom: 12 }}>
          <input type="checkbox" checked={rights} onChange={() => setRights(!rights)} style={{ accentColor: tokens.color.accent }} />
          I confirm I hold the rights to this release
        </label>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <StatChip label="Readiness" value={`${report.score}`} tone={report.status === "ready" ? "ok" : report.status === "blocked" ? "warn" : "accent"} />
          <Badge tone={report.status === "ready" ? "ok" : report.status === "blocked" ? "warn" : "accent"}>{report.status.replace(/_/g, " ")}</Badge>
        </div>
        {report.blockers.slice(0, 4).map((b, i) => <div key={i} style={{ fontSize: 12, color: tokens.color.danger, marginTop: 6 }}>✕ {b}</div>)}
      </PanelShell>
      <PanelShell title="DistroKid bridge" style={{ marginTop: 12 }}>
        <p style={{ margin: 0, color: tokens.color.textDim, fontSize: 13 }}>
          Manual submission pack today — no credential storage, no browser automation. A future
          verified API adapter stays isolated behind the capability boundary.
        </p>
      </PanelShell>
    </>
  );
}
